import Footer from "../components/Landing Page/Footer";
import GoodThings from "../components/Landing Page/GoodThings";
import Navbar from "../components/Landing Page/Navbar";


const LandingPage = () => {
  return (
    <>
      <GoodThings />
    </>
  );
};

export default LandingPage;
